<template>
  <div v-if="Object.keys(data.stepData).length > 0 && stateIsReady">
    <!-- DESKTOP -->
    <div class="header-logos desktop-only">
      <div>
        <img
          alt="Banca Profilo"
          style="width: 140px;"
          src="../assets/images/logo_bp-min.jpg"
        />
      </div>
      <div>
        <img
          style="width: 100px;"
          src="../assets/images/logo_tinaba.png"
          alt="Tinaba"
        />
      </div>
    </div>
    <div
      v-if="!data.hideHeader && !isFirstStep"
      class="header-steps-desktop desktop-only mb-5"
    >
      <div class="flex">
        <div>{{ data.stepData.index }}. {{ data.stepData.title }}</div>
      </div>
      <div class="steps-status mt-2">
        <div
          class="steps-status-box"
          :class="{ active: data.stepData.index >= 1 }"
        >
          Dati personali
        </div>
        <div
          class="steps-status-box"
          :class="{ active: data.stepData.index >= 2 }"
        >
          Adeguata verifica
        </div>
        <div
          class="steps-status-box"
          :class="{ active: data.stepData.index >= 3 }"
        >
          Consenso privacy
        </div>
        <div
          class="steps-status-box"
          :class="{ active: data.stepData.index === 4 }"
        >
          Firma contratto
        </div>
      </div>
    </div>

    <!-- MOBILE & TABLET -->
    <div v-if="!data.hideHeader" class="header-steps-mobile mobile-only">
      <div class="flex">
        <!-- We hide the 'back' button if we're at the first step, unless we come from APP.
             In that case we could go back to the previous app page -->
        <div @click="back()" class="mr-3 flex back-container">
          <div class="icon icon-back"></div>
        </div>
        <div>
          {{ data.stepData.index }}{{ data.stepData.index ? "." : "" }}
          {{ data.stepData.title }}
        </div>
      </div>
      <div @click="openHelp" class="icon icon-info js-open-help"></div>
    </div>
    <div v-if="!data.hideHeader" class="mb-8 mobile-only">
      <ProgressBar :value="data.stepData.progressPercentage" />
    </div>

    <!-- If we have no header set some margin -->
    <div v-if="data.hideHeader" class="mt-10"></div>
  </div>
</template>

<script>
import ProgressBar from "@/components/ProgressBar";
import UtilityService from "@/services/UtilityService";
import AppFlow from "../AppFlow";
import store from "@/store";

export default {
  name: "Header",
  components: {
    ProgressBar
  },

  data() {
    return {
      isFromApp: false,
      isFirstStep: false,
      data: {
        stepData: {}
      }
    };
  },
  computed: {
    userIsLoggedIn() {
      return store.state.loggedIn;
    },
    appReady() {
      return store.state.appReady;
    },
    // a computed getter
    isFirstStepFromApp: function() {
      // `this` points to the vm instance
      return this.isFromApp && this.isFirstStep;
    },
    stateIsReady: function() {
      return this.$store.state.currentStep !== undefined;
    }
  },
  mounted() {
    //this.url = process.env.VUE_APP_API_URL;
    setTimeout(() => {
      this.isFromApp = sessionStorage.getItem("fromApp");
    }, 300);

    this.$root.$on(`storeUpdated@setAppReady`, state => {
      if (state.appReady) this.onAppReady();
    });

    this.$root.$on("changedRoute", this.changedRoute);
    this.$root.$on("popstate", this.popstate);
  },
  methods: {
    back() {
      if (this.isFirstStepFromApp) {
        UtilityService.sendPostMessage({ action: "userAction", type: "back" });
      } else {
        this.$router.go(-1);
      }
    },
    changedRoute() {
      console.log("changedRoute");
      this.getData();
    },
    popstate() {
      console.log("popstate");

      //If user goes back to the Home page and comes from App
      //He should be redirect to the App's homepage
      const userComesFromApp = sessionStorage.getItem("fromApp");
      const isBackToHomePage = this.$router.currentRoute.name === "Home";
      if (userComesFromApp && isBackToHomePage) {
        UtilityService.sendPostMessage({
          action: "userAction",
          type: "backToSplashPage"
        });
        return;
      }
      this.getData();
    },
    onAppReady() {
      console.log(" *** APP READY ***");
      this.getData();
    },
    getData() {
      console.log("Updating Header... ", this.$router.currentRoute);
      this.data = this.$router.currentRoute.meta;
      const currentStep = AppFlow.getCurrentStep();
      const currentSubstep = AppFlow.getCurrentSubstepIndex(
        this.$router.currentRoute.name
      );

      if (currentSubstep === -1) {
        console.error(
          "ERROR: Route not defined. Please add it on ./router/index.js file"
        );
      }
      console.log(
        "Current Step: " + currentStep + " - Substep: " + currentSubstep
      );
      const isLandingPage = currentStep === 0 && currentSubstep === 0;
      const isFirstRegistrationStep = currentStep === 1 && currentSubstep === 0;
      this.isFirstStep = isLandingPage || isFirstRegistrationStep;
    },
    openHelp() {
      this.$root.$emit("openHelp");
    }
  }
};
</script>

<style scoped lang="less">
.header-logos {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  //width: 768px;
  margin: 0 50px;
}

.header-steps-desktop {
  height: 100px;
  font-size: 21px;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
  .steps-status {
    font-size: 13px;
    display: flex;
    width: 668px;
    .steps-status-box {
      padding: 5px;
      width: 25%;
      border-bottom: 2px solid #eaeaea;

      &.active {
        border-bottom: 2px solid #CC4B00;
      }
    }
  }
}
.header-steps-mobile {
  height: 80px;
  font-size: 21px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  .icon-back {
    width: 10px;
    height: 20px;
  }
  .icon-info {
    width: 27px;
    height: 27px;
  }
  .back-container {
    padding: 5px 10px;
    align-items: center;
  }
}
</style>
